"use client";

import * as React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const processSteps = [{
  title: "01. Research",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/process_tour_planner.png",
  link: "/CurationPage"
}, {
  title: "02. Connection",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/process_tour_packages.png",
  link: "/OurStoryPage"
}, {
  title: "03. Experience",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/process_car_rental.png",
  link: "/ImpactPage"
}];
export default function DesignYourIdealJourney() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="184815" id="our-curation-process" className="bg-background py-20 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-6xl font-serif text-secondary mb-4 tracking-widest uppercase">
              Our Curation Process
            </h2>
            <p className="text-muted-foreground max-w-2xl mx-auto text-lg font-sans leading-relaxed">
              Don’t just travel, PS Travel. We believe in collective discovery and leaving every destination better than we found it.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {processSteps.map((step, i) => <Link key={step.title} to={step.link} data-index={i} className="block group outline-none focus-visible:ring-2 focus-visible:ring-primary rounded-lg">
                <Card className="relative h-[480px] overflow-hidden border-0 rounded-lg shadow-2xl transition-all duration-500 group-hover:shadow-primary/20 bg-card">
                  <div className="absolute inset-0 overflow-hidden rounded-lg">
                    <img src={step.image} alt={step.title} className="w-full h-full object-cover transition-transform duration-1000 ease-in-out group-hover:scale-110 opacity-80 group-hover:opacity-100" />
                  </div>
                  
                  {}
                  <div className="absolute inset-0 bg-gradient-to-t from-background/95 via-background/40 to-transparent pointer-events-none rounded-lg" />
                  
                  <CardContent className="absolute inset-0 p-8 flex flex-col justify-end text-center z-10">
                    <h3 className="text-5xl md:text-6xl font-default text-secondary tracking-tighter drop-shadow-2xl transition-transform duration-500 group-hover:-translate-y-4">
                      {step.title}
                    </h3>
                  </CardContent>
                </Card>
              </Link>)}
          </div>
        </div>
      </div>
    </section>;
}